import bankLinks from '@client/events/listeners/bankLinks';
import plaid from '@client/events/listeners/plaid';
import userSummary from '@client/events/listeners/userSummary';

export const modules = [bankLinks, plaid, userSummary];

export default {
  register() {
    modules.forEach((module) => module.register());
  },
};
